import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AlterarArquivoExtratoPayload} from '../../core/alterar-arquivo-extrato-payload';
import {ArquivoExtrato} from '../../core/arquivo-extrato';
import {FiltroArquivoExtrato} from '../../core/filtro-arquivo-extrato';
import {Page} from '../../core/page';
import {BaseService} from '../base/base.service';
import {Rotas} from '../../core/rotas';

@Injectable({
    providedIn: 'root'
})
export class ArquivoExtratoService extends BaseService<ArquivoExtrato> {

    constructor(http: HttpClient) {
        super(http, Rotas.ARQUIVO_EXTRATO);
    }

    importarArquivo(file: File): Observable<ArquivoExtrato> {
        const formData = new FormData();
        formData.append('file', file);

        return this.http.post<ArquivoExtrato>(`${Rotas.ARQUIVO_EXTRATO}importar`, formData);
    }

    pesquisarPaginado(filtro: FiltroArquivoExtrato, page: number, pageSize: number): Observable<Page<ArquivoExtrato>> {
        const headers = new HttpHeaders()
            .set('page', page.toString())
            .set('pageSize', pageSize.toString());

        return this.http.post<Page<ArquivoExtrato>>(`${Rotas.ARQUIVO_EXTRATO}pesquisar/paginado`, filtro, {headers});
    }

    alterarArquivoExtrato(idArquivo: number, payload: AlterarArquivoExtratoPayload): Observable<void> {
        return this.http.put<void>(`${Rotas.ARQUIVO_EXTRATO}${idArquivo}`, payload);
    }

    finalizarImportacao(idArquivo: number): Observable<string> {
        return this.http.post(`${Rotas.ARQUIVO_EXTRATO}${idArquivo}/finalizar`, {}, {responseType: 'text'});
    }

    marcarLinhaCorrigida(idArquivo: number, idLinha: number): Observable<any> {
        return this.http.post<any>(`${Rotas.ARQUIVO_EXTRATO}${idArquivo}/linha/${idLinha}/marcar-corrigido`, {});
    }

    reprocessar(idArquivo: number): Observable<string> {
        return this.http.post(`${Rotas.ARQUIVO_EXTRATO}${idArquivo}/reprocessar`, {}, {responseType: 'text'});
    }

}
